import Notices from "../utils/Notices";

function init($) {
  const noticesWrapper = document.querySelector('.woocommerce-notices-wrapper');
  console.log(noticesWrapper);
  if (noticesWrapper) {
    const config = { childList: true, subtree: true };

    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type == 'childList') {
          console.log(mutation.addedNodes);
          mutation.addedNodes.forEach(node => {
            if(node.nodeType===node.ELEMENT_NODE){
              const notices = node.getAttribute('data-notice')
              const type = node.getAttribute('data-notice-type')
              Notices.show(notices, type)
            }
          })
        }
      }
    });

    observer.observe(noticesWrapper, config);

    const noticesEl = noticesWrapper.querySelectorAll('.js-woocomerce-notices');
    noticesEl.forEach(node => {
      const notice = node.getAttribute('data-notice')
      const type = node.getAttribute('data-notice-type')
      console.log(notice);
      Notices.show(notice, type)
    })
  }

  $( document.body ).on('checkout_error', () => {
    const noticesEl = document.querySelectorAll('.js-woocomerce-notices');
    noticesEl.forEach(node => {
      const notice = node.getAttribute('data-notice')
      let type = node.getAttribute('data-notice-type')
      if (type === "danger") {
        type = "error"
      }
      console.log(notice);
      Notices.show(notice, type)
    })
  })
}


export default { init }